import { KnBrDirectiveModule } from 'src/app/shared/directive/kn-br-directive.module';
import { KnBrAddToQuoteModule } from './../../kn-br-product/kn-br-add-to-quote/kn-br-add-to-quote.module';
import { KnBrAddToCartModule } from './../../kn-br-product/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { MediaModule, CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { I18nModule, ConfigModule, CmsConfig, RoutingConfig, AuthGuard } from '@spartacus/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KnBrQuickOrderComponent } from './kn-br-quick-order.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        FormsModule,
        ReactiveFormsModule,
        I18nModule,
        MediaModule,
        KnBrAddToCartModule,
        KnBrAddToQuoteModule,
        KnBrDirectiveModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrQuickOrderComponent: {
                    component: KnBrQuickOrderComponent,
                },
            },
        } as CmsConfig),
        RouterModule.forChild([
            {
                data: { pageLabel: '/quick-order', cxRoute: 'quickOrder' },
                path: null,
                canActivate: [AuthGuard, CmsPageGuard],
                component: PageLayoutComponent,
            },
        ]),
        ConfigModule.withConfig({
            routing: {
                routes: {
                    quickOrder: {
                        paths: ['quick-order'],
                    },
                },
            },
        } as RoutingConfig),
        KnBrQuickOrderComponent,
    ],
})
export class KnBrQuickOrderModule {}
